(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('floating-actions')) {
    customElements.define(
      'floating-actions',
      class FloatingActions extends HTMLElement {
        static storageKey = 'kc-a11y';

        connectedCallback() {
          this.menu = document.getElementById('AccessibilityMenu');
          this.initLift();
          if (this.menu) this.initMenu();
        }

        // Keep the buttons above whichever bottom bar is showing.
        initLift() {
          const update = () => {
            let lift = 0;
            document.querySelectorAll('[data-sticky-atc].is-visible').forEach((bar) => {
              lift = Math.max(lift, bar.getBoundingClientRect().height);
            });
            document.documentElement.style.setProperty('--floating-lift', `${Math.round(lift)}px`);
            // The language banner is short-lived: step aside while it shows (lifted, the buttons
            // would sit on the hero buttons) and come back once it is closed.
            this.classList.toggle('is-hidden', !!document.querySelector('language-suggestion:not([hidden])'));
          };
          const watch = () => {
            document.querySelectorAll('[data-sticky-atc], language-suggestion').forEach((bar) => {
              observer.observe(bar, { attributes: true, attributeFilter: ['class', 'hidden'] });
              resize.observe(bar);
            });
            update();
          };
          const observer = new MutationObserver(update);
          const resize = new ResizeObserver(update);
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
          else watch();
        }

        initMenu() {
          this.state = this.read();
          this.render();
          this.menu.addEventListener('click', (event) => {
            const option = event.target.closest('[data-a11y]');
            if (option) {
              const key = option.dataset.a11y;
              if (this.state.includes(key)) this.state = this.state.filter((item) => item !== key);
              else this.state.push(key);
              this.save();
            } else if (event.target.closest('[data-a11y-reset]')) {
              this.state = [];
              this.save();
            }
          });
        }

        read() {
          try {
            return JSON.parse(localStorage.getItem(FloatingActions.storageKey)) || [];
          } catch (error) {
            return [];
          }
        }

        save() {
          try {
            localStorage.setItem(FloatingActions.storageKey, JSON.stringify(this.state));
          } catch (error) {
            // Storage blocked: settings still apply until the page changes.
          }
          this.render();
        }

        render() {
          const root = document.documentElement;
          this.menu.querySelectorAll('[data-a11y]').forEach((option) => {
            const on = this.state.includes(option.dataset.a11y);
            option.setAttribute('aria-pressed', String(on));
            root.classList.toggle(`a11y-${option.dataset.a11y}`, on);
          });
          const still = this.state.includes('motion');
          document.querySelectorAll('video').forEach((video) => still && video.pause());
          if (!still) document.querySelectorAll('hero-video').forEach((hero) => hero.play?.());
          if (still) document.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-revealed'));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-suggestion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('language-suggestion')) {
    customElements.define(
      'language-suggestion',
      class LanguageSuggestion extends HTMLElement {
        static storageKey = 'kc-language-suggestion-dismissed';

        connectedCallback() {
          try {
            if (localStorage.getItem(LanguageSuggestion.storageKey)) return;
          } catch (error) {
            // Storage blocked: still show the banner, just can't remember dismissal.
          }

          const current = document.documentElement.lang.split('-')[0];
          const preferred = (navigator.languages || [navigator.language]).map((l) => l.toLowerCase().split('-')[0]);
          const offers = [...this.querySelectorAll('[data-language]')];
          // Only suggest when the visitor's top preference is another available language.
          const top = preferred[0];
          if (!top || top === current) return;
          const offer = offers.find((el) => el.dataset.language === top);
          if (!offer) return;

          offer.hidden = false;
          this.hidden = false;
          this.querySelector('[data-dismiss]').addEventListener('click', () => this.dismiss());
          const link = offer.querySelector('a');
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => window.localizeLink?.(link), { once: true });
          } else {
            window.localizeLink?.(link);
          }
          link.addEventListener('click', () => this.remember());
        }

        remember() {
          try {
            localStorage.setItem(LanguageSuggestion.storageKey, '1');
          } catch (error) {}
        }

        dismiss() {
          this.remember();
          this.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('localization-form')) {
    customElements.define(
      'localization-form',
      class LocalizationForm extends HTMLElement {
        connectedCallback() {
          this.querySelector('select')?.addEventListener('change', (event) => event.target.form.submit());
          // theme.js (deferred) defines localizeLink; it has run by DOMContentLoaded.
          const localize = () => this.querySelectorAll('[data-keep-query]').forEach((link) => window.localizeLink?.(link));
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', localize, { once: true });
          } else {
            localize();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
